import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfca7b58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))

import { useGame } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigator',
  setup(__props) {

const { clearCharacter, logout } = useGame();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "back_btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearCharacter)()))
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('RESULT__BUTTON__BACK')), 1)
    ]),
    _createElementVNode("button", {
      class: "logout_btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(logout)()))
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('RESULT__BUTTON__LOGOUT')), 1)
    ])
  ]))
}
}

})